import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  CircularProgress,
  Box,
  MenuItem,
} from "@mui/material";
import useUpdate from "../../api/useUpdate";
import useFetchObjects from "../../api/useFetchObjects";
import { useTranslation } from "react-i18next";
import {
  getFormDirection,
  getRtlSelectProps,
  getRtlTextFieldProps,
} from "../utils/rtlForm";

const ExpenseCategoryEdit = ({ open, onClose, editData, token }) => {
  const { t, i18n } = useTranslation();
  const formDirection = getFormDirection(i18n);
  const { fieldDirection } = formDirection;
  const selectProps = getRtlSelectProps(formDirection);
  const { handleUpdate, loading, isSuccess } = useUpdate(
    "shop/expense-categories",
    token
  );

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [shop, setShop] = useState("");

  const { data: shopsData } = useFetchObjects(
    ["shops"],
    "shop/shop",
    token
  );
  const shops = shopsData?.results || shopsData || [];

  useEffect(() => {
    if (editData) {
      setName(editData.name || "");
      setDescription(editData.description || "");
      setShop(editData.shop || "");
    }
  }, [editData]);

  const handleSubmit = () => {
    const formData = new FormData();
    formData.append("name", name);
    formData.append("description", description);
    formData.append("shop", shop);
    handleUpdate(editData.id, formData);
  };

  useEffect(() => {
    if (isSuccess) {
      setName("");
      setDescription("");
      setShop("");
      onClose();
    }
  }, [isSuccess, onClose]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" dir={fieldDirection}>
      <DialogTitle>{t("expenseCategory.editExpenseCategory")}</DialogTitle>
      <DialogContent>
        <Box component="form" noValidate sx={{ mt: 1, direction: fieldDirection }}>
          <TextField
            margin="dense"
            label={t("expenseCategory.name")}
            fullWidth
            required
            value={name}
            onChange={(e) => setName(e.target.value)}
            {...getRtlTextFieldProps(formDirection)}
          />
          <TextField
            margin="dense"
            label={t("expenseCategory.description")}
            fullWidth
            multiline
            rows={3}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            {...getRtlTextFieldProps(formDirection)}
          />
          <TextField
            select
            margin="dense"
            label={t("expenseCategory.shop", "Branch")}
            fullWidth
            required
            value={shop}
            onChange={(e) => setShop(e.target.value)}
            SelectProps={selectProps}
            {...getRtlTextFieldProps(formDirection)}
          >
            {shops.map((s) => (
              <MenuItem key={s.id} value={s.id}>
                {s.name}
              </MenuItem>
            ))}
          </TextField>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          {t("expenseCategory.cancel")}
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={loading || !name || !shop}
        >
          {loading ? (
            <CircularProgress size={24} />
          ) : (
            t("expenseCategory.save")
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ExpenseCategoryEdit;
